import { FetchEventSeatingGroupsParams, FetchEventTicketGroupsParams } from 'api/events';
import { campaignQueryKeys } from 'queries/campaign-query-keys';

const eventQueryKeys = {
    event: (campaignId: number) => [...campaignQueryKeys.campaign(campaignId), 'events'],
    eventById: (eventId: number) => ['events', eventId],
    ticketGroups: (eventId: number) => [...eventQueryKeys.eventById(eventId), 'ticketGroups'],
    ticketGroupsWithFilters: (eventId: number, params: FetchEventTicketGroupsParams = {}) => [
        ...eventQueryKeys.ticketGroups(eventId),
        params,
    ],
    seatingGroups: (eventId: number) => [...eventQueryKeys.eventById(eventId), 'seatingGroups'],
    seatingGroupsWithFilters: (eventId: number, params: FetchEventSeatingGroupsParams) => [
        ...eventQueryKeys.seatingGroups(eventId),
        params,
    ],
    seatingGroup: (eventId: number, seatingGroupId: number) => [
        ...eventQueryKeys.seatingGroups(eventId),
        seatingGroupId,
    ],
    tableSeatingStats: (eventId: number) => [
        ...eventQueryKeys.eventById(eventId),
        'tableSeatingStats',
    ],
    seatingLayout: (eventId: number) => [...eventQueryKeys.eventById(eventId), 'seatingLayout'],
    seatingStats: (eventId: number) => [...eventQueryKeys.eventById(eventId), 'seatingStats'],
};

export { eventQueryKeys };
